import React from "react";
import classNames from "classnames";
import { Box, Select } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import InfoIcon from "@mui/icons-material/Info";
import { CustomTooltip } from "../tooltip/Tooltip";

const CustomSelect = ({
  value,
  placeholder,
  customClass,
  showLabel,
  className,
  showLabelInfoIcon,
  labelInfoTooltipContent,
  setCustomIcon = false,
  ...props
}) => {
  const handleKeyPress = (e) => {
    if (e.nativeEvent.keyCode === 13 && props.onEnterPress) {
      props.onEnterPress();
    }
  };

  return (
    <Box className={customClass}>
      <Box display="flex">
        {showLabel && (
          <label className="input-with-dropdown-label">{props.label}</label>
        )}
        {showLabelInfoIcon && labelInfoTooltipContent && (
          <CustomTooltip
            arrow={true}
            placement="top"
            text={labelInfoTooltipContent}
            className="custom-tooltip payments-status-tooltip"
          >
            <Box
              sx={{
                width: "fit-content",
                boxShadow: "none",
                marginLeft: "6px",
                position: "relative",
                top: "2px",
              }}
            >
              <InfoIcon
                style={{
                  height: 20,
                  width: 20,
                  color: "#848b9e",
                  cursor: "pointer",
                }}
              />
            </Box>
          </CustomTooltip>
        )}
      </Box>

      <Select
        name={props.name}
        className={classNames("select", className)}
        displayEmpty
        value={value}
        placeholder={placeholder}
        onKeyPress={handleKeyPress}
        onChange={(e) => {
          props.onChange(e);
        }}
        IconComponent={(_props) => (
          <>
            {setCustomIcon ? (
              setCustomIcon(_props)
            ) : (
              <KeyboardArrowDownIcon
                style={{
                  width: 21,
                  height: 25,
                  color: _props.disabled ? "rgba(0,0,0,0.26)" : "#848B9E",
                }}
                {..._props}
              />
            )}
          </>
        )}
        {...props}
      />
    </Box>
  );
};

export default CustomSelect;
